<template>
  <div :style="{height:height,width:width}">
    <!-- <v-layout row wrap>
      <v-flex lg4 md2 offset-lg-4 offset-md-2>
        <v-btn small dark :class='buttonColor' @click.native="downloadCSV">
          <json-excel type="csv" :data="exportxls" name="Data.csv">
            Download CSV
          </json-excel>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap mt-0>
      <v-flex lg10 md10>
        <v-text-field
          solo
          style="color: black;"
          clearable
          @keyup.enter="initTable"
          placeholder="Search here..."
          v-model="text"
        >
        <template v-slot:append-outer>
          <v-btn
            dark
            absolute
            :class='buttonColor'
            @click.native="downloadCSV"
            style="outline: none; width: 150px; height: 50px; top: 22px; right: 90px; text-transform: none; font-size: 16px;"
          >
            <json-excel type="csv" :data="exportxls" name="Data.csv">
              Download CSV
            </json-excel>
          </v-btn>
        </template>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-3>
      <v-flex lg3 md3>
        <v-select
          :items="options"
          v-model="headers"
          label="Fields"
          multiple
          chips
          dark
          hint="Choose the fields you want"
          persistent-hint/>
      </v-flex>
      <v-flex lg3 offset-lg6 md2 offset-md6>
        <v-select :items="pageOptions" dark label="Items per page" v-model="perPage"/>
      </v-flex>
    </v-layout>
    <circle8 class="center" v-if="isLoading" style="position: absolute; top: 80px; left: 50%;"></circle8>
    <div v-if="items && items.length">
      <!-- TABLE Start Here -->
      <b-table  responsive
                :items="items"
                :fields="fields"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :current-page="currentPage"
                :per-page="perPage"
                dark>
        <template slot="rawData" slot-scope="row">
          <v-btn small @click.stop="row.toggleDetails" class="mr-2">
            {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
          </v-btn>
        </template>
        <template slot="row-details" slot-scope="row">
          <v-card dark>
            <v-layout row class="mb-2">
              <v-flex>{{ row.item._raw }}</v-flex>
            </v-layout>
            <v-flex class="mb-2">
            </v-flex>
            <v-btn small @click="row.toggleDetails">Hide Details</v-btn>
          </v-card>
        </template>
      </b-table>
      <b-pagination size="md" align="center" :total-rows="1000" v-model="currentPage" :per-page="perPage"></b-pagination>
    </div>
    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="8000"
      :top="true"
      :vertical="false"
    >
      {{ snackbartext }}
      <v-btn
        color="pink"
        flat
        style="outline: none;"
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import pdfMake from 'pdfmake/build/pdfmake'
  import pdfFonts from 'pdfmake/build/vfs_fonts'
  import JsonExcel from 'vue-json-excel'
  import jwtDecode from 'jwt-decode'
  import {
    Circle8
  } from 'vue-loading-spinner'

  pdfMake.vfs = pdfFonts.pdfMake.vfs

  export default {
    name: 'rawTable',
    components: {
      Circle8,
      JsonExcel
    },
    data () {
      return {
        snackbar: false,
        snackbartext: '',
        text: '',
        fields: [
          {key: '@timestamp', sortable: true},
          {key: 'event_type', sortable: true},
          {key: 'mod', sortable: true},
          {key: 'cmd', sortable: true},
          {key: 'rawData', sortable: false}
        ],
        items: [],
        options: [
          {text: 'Host', value: 'host'},
          {text: 'Action', value: 'action'},
          {text: 'Event Type', value: 'event_type'},
          {text: 'Type', value: 'cmd'}
        ],
        headers: [],
        currentPage: 1,
        perPage: 20,
        pageOptions: [10, 20, 50],
        sortBy: '@timestamp',
        sortDesc: false,
        isLoading: true,
        buttonColor: null,
        refreshInterval: null,
        exportxls: [],
        ampid: '',
        token: ''
      }
    },
    created () {
      this.token = sessionStorage.getItem('user-token')
      let decoded = jwtDecode(this.token)
      this.ampid = decoded.ampid
      if (partner === 'inet') {
        this.buttonColor = 'green'
      } else if (partner === 'ais') {
        this.buttonColor = 'green darken-3'
      } else {
        this.buttonColor = 'light-blue darken-3'
      }
    },
    props: {
      user_inst: {
        type: String
      },
      username: String,
      height: {
        type: String,
        default: '100%'
      },
      width: {
        type: String,
        default: '100%'
      },
      user_index: {
        type: String
      },
      startTime: {
        type: String
      },
      endTime: {
        type: String
      },
      refreshTime: {
        type: Number
      }
    },
    methods: {
      handleDownload () {},
      async initTable () {
        window.analytics.track('[Search][rawlog]', {
          value: {
            keyword: this.text
          }
        }, {
          integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
        this.isLoading = true
        this.disposeTable()
        let text = ''
        if (this.user_index === 'fortigate' || this.user_index === 'sophos') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'action', label: 'Action', sortable: true},
            {key: 'dest_interface', label: 'Dest interface', sortable: true},
            {key: 'policy_id', label: 'Policy ID', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'action', value: 'action'},
            {text: 'dest_interface', value: 'dest_interface'},
            {text: 'policy_id', value: 'policy_id'}
          ]
        } else if (this.user_index === 'juniper') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'service-name', label: 'Service Name', sortable: true},
            {key: 'policy_id', label: 'Policy ID', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'service-name', value: 'service-name'},
            {text: 'policy_id', value: 'policy_id'}
          ]
        } else if (this.user_index === 'watchguard') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'dest_port', label: 'Destination Port', sortable: true},
            {key: 'policy_id', label: 'Policy ID', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'dest_port', value: 'dest_port'},
            {text: 'policy_id', value: 'policy_id'}
          ]
        } else if (this.user_index === 'apache') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'http_method', label: 'HTTP Method', sortable: true},
            {key: 'http_status', label: 'HTTP Status', sortable: true},
            {key: 'request', label: 'Request', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'http_method', value: 'http_method'},
            {text: 'http_status', value: 'http_status'},
            {text: 'request', value: 'request'}
          ]
        } else if (this.user_index === 'palo') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'action', label: 'Action', sortable: true},
            {key: 'rule', label: 'rule', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'action', value: 'action'},
            {text: 'rule', value: 'rule'}
          ]
        } else if (this.user_index === 'pfsense') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'action', label: 'Action', sortable: true},
            {key: 'protocol', label: 'Protocol', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'action', value: 'action'},
            {text: 'protocol', value: 'protocol'}
          ]
        } else if (this.user_index === 'office') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'action', label: 'Action', sortable: true},
            {key: 'eventId', label: 'eventId', มsortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'action', value: 'action'},
            {text: 'eventId', value: 'eventId'}
          ]
        } else if (this.user_index === 'bluecoat') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'http_method', label: 'HTTP Method', sortable: true},
            {key: 'http_status', label: 'HTTP Status', sortable: true},
            {key: 'protocol', label: 'Protocol', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'http_method', value: 'http_method'},
            {text: 'http_status', value: 'http_status'},
            {text: 'protocol', value: 'protocol'}
          ]
        } else if (this.user_index === 'squid') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'method', label: 'Method', sortable: true},
            {key: 'http_status', label: 'HTTP Status', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'method', value: 'method'},
            {text: 'http_status', value: 'http_status'}
          ]
        } else if (this.user_index === 'mikrotik') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'src_ip', label: 'Source IP', sortable: true},
            {key: 'dest_ip', label: 'Destination IP', sortable: true},
            {key: 'event_name', label: 'Event Name', sortable: true},
            {key: 'protocol', label: 'Protocol', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'src_ip', value: 'src_ip'},
            {text: 'dest_ip', value: 'dest_ip'},
            {text: 'event_name', value: 'event_name'},
            {text: 'protocol', value: 'protocol'}
          ]
        } else if (this.user_index === 'windows') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'hostname', label: 'Hostname', sortable: true},
            {key: 'event_id', label: 'Event ID', sortable: true},
            {key: 'event_type', label: 'Event Type', sortable: true},
            {key: 'target_user', label: 'Target User', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'hostname', value: 'hostname'},
            {text: 'event_id', value: 'event_id'},
            {text: 'event_type', value: 'event_type'},
            {text: 'target_user', value: 'target_user'}
          ]
        } else if (this.user_index === 'exchange') {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'sender_address', label: 'Sender Address', sortable: true},
            {key: 'recp_address', label: 'Recipient Address', sortable: true},
            {key: 'event_name', label: 'Event Name', sortable: true},
            {key: 'message_subject', label: 'Message Subject', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
            {text: 'hostname', value: 'hostname'},
            {text: 'event_id', value: 'event_id'},
            {text: 'event_name', value: 'event_name'},
            {text: 'message_subject', value: 'message_subject'}
          ]
        } else {
          this.fields = [
            {key: '@timestamp', label: 'Timestamp', sortable: true},
            {key: 'rawData', label: 'Raw Data', sortable: false}
          ]
          this.options = [
          ]
        }
        let fields = []

        if (this.text) {
          // Split the query string to seperated keywords and filter the field zone out
          let words = this.text.match(/\w+\s?!?=\s?["'(].+?["')]|\|\sfields\s(?=\w+)|\S+/g)
          let seperatorIndex = words.findIndex(element => element === '| fields ')
          // Set table header to display only selected fields (EXCEPT @timestamp & raw_data)
          if (seperatorIndex !== -1) {
            fields = words.splice(seperatorIndex + 1)
            words.pop()
          }
          if (this.headers.length > 0) {
            this.headers.forEach(header => {
              if (!fields.includes(header)) {
                fields.push(header)
              }
            })
          }
          if (fields.length > 0) {
            this.fields = [
              { key: '@timestamp', label: 'Timestamp', sortable: true }
            ]
            fields.forEach(field => {
              let label
              if (field !== '@timestamp' && field !== 'rawData') {
                switch (field) {
                  case 'src_ip':
                    label = 'Source IP'
                    break
                  case 'dest_ip':
                    label = 'Destination IP'
                    break
                  case 'dest_port':
                    label = 'Destination Port'
                    break
                  case 'action':
                    label = 'Action'
                    break
                  case 'user':
                    label = 'User'
                    break
                  case 'bytes_in':
                    label = 'Bytes in'
                    break
                  case 'bytes_out':
                    label = 'Bytes out'
                    break
                  case 'service':
                    label = 'Service'
                    break
                }
                this.fields.push({ key: field, label, sortable: true })
              }
            })
            this.fields.push({ key: 'rawData', label: 'Raw Data', sortable: false })
          }
          // Transform some keywords
          let textArray = []
          words.forEach(word => {
            if (word.match(/!=\s?(?=["'(].*["')])/g)) { // field!="value" -> field:(NOT value)
              textArray.push(word.replace(/!=\s?["'(](.*?)["')]/g, ':(NOT ($1))'))
            } else if (word.match(/=\s?(?=["'()].*["')])/g)) { // field="value" -> field:(value)
              textArray.push(word.replace(/=\s?["'(](.*?)["')]/g, ':($1)'))
            } else {
              textArray.push(word)
            }
          })
          text = textArray.join(' ')
        }
        axios.post(apiUrl + '/api/dashboard/stage',
          {
            type: 'search',
            action: 'SearchRaw',
            username: this.username,
            index: this.user_index,
            query_string: this.text
          })
        let response = await axios.post(apiUrl + '/api/query/search', {
          start: this.startTime,
          end: this.endTime,
          index: this.user_index,
          instance: this.user_inst,
          stores: [],
          text,
          fields
        })
        this.isLoading = false
        for (let i = 0; i < response.data.length; i++) {
          response.data[i]._source['@timestamp'] = new Date(response.data[i]._source['@timestamp']).toString()
          response.data[i]._source['_raw'] = JSON.stringify(response.data[i]._source['_raw']).replace(/"/g, '').replace(/\\/g, '')
          this.items.push(response.data[i]._source)
        }
        this.exportxls = response.data.map(dessert => {
          return {
            ...dessert._source,
            ...dessert._source.geoip
          }
        })
        this.exportxls = this.exportxls.map(dessert => {
          delete dessert.geoip
          delete dessert.location
          return {
            ...dessert
          }
        })
      },
      disposeTable () {
        this.items = []
      },
      // downloadPDF () {
      //   alert('You can export max 10,000 event (Please wait, we are loading the data for you.)')
      //   axios.post(apiUrl + '/api/dashboard/stage',
      //     {
      //       type: 'export',
      //       action: 'ExportSearchPDF',
      //       username: this.username,
      //       index: this.user_index
      //     })
      //   let body = [
      //     ['Raw Data']
      //   ]
      //   this.items.forEach(element => {
      //     body.push([element._raw])
      //   })
      //   let doc = {
      //     header: 'Export Raw Data',
      //     footer: 'Powered by Ragnar',
      //     content: [
      //       {
      //         table: {
      //           headerRows: 1,
      //           body
      //         }
      //       }
      //     ]
      //   }
      //   pdfMake.createPdf(doc).download('RawData.pdf')
      // },
      downloadCSV () {
        window.analytics.track('[DownloadCSV]', {}, {
          integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
        this.snackbartext = 'You can export max 10,000 event (Please wait, we are loading the data for you.)'
        this.snackbar = true
        // alert('You can export max 10,000 event (Please wait, we are loading the data for you.)')
        axios.post(apiUrl + '/api/dashboard/stage',
          {
            type: 'export',
            action: 'ExportSearchCSV',
            username: this.username,
            index: this.user_index
          })
      }
    },
    mounted () {
      this.initTable()
    },
    watch: {
      startTime: {
        handler: function (startTime) {
          this.disposeTable()
          this.initTable()
        }
      },
      endTime: {
        handler: function (endTime) {
          this.disposeTable()
          this.initTable()
        }
      },
      headers: {
        handler: function (headers) {
          this.disposeTable()
          this.initTable()
        }
      },
      user_index: {
        handler: function (user_index) {
          this.disposeTable()
          this.initTable()
        }
      },
      refreshTime: {
        handler: function (refreshTime) {
          if (refreshTime === 0) {
            clearInterval(this.refreshInterval)
          } else {
            clearInterval(this.refreshInterval)
            this.refreshInterval = setInterval(function () {
              this.disposeTable()
              this.initTable()
            }.bind(this), refreshTime)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .center {
    float: none;
    margin: 0 auto;
    padding-top: 20%
  }
</style>



// WEBPACK FOOTER //
// src/components/rawTable.vue